import { TagsOptions } from 'src/types/Main'
import GridValue from './GridValue'

interface Props {
  tagType: string;
  filters: TagsOptions[];
  filteredTags: Record<string, string[]>;
  setFilteredTags(tags: Record<string, string[]>): void;
  filterOnClick: boolean;
}

const GridOptions = (props: Props) => {
  const {
    filters,
    filteredTags,
    setFilteredTags,
    tagType,
    filterOnClick
  } = props

  return (
    <div
      className="content-wrapper"
    >
      {filters.map((filter: TagsOptions, key: number) => (
        <GridValue
          key={key}
          tagType={tagType}
          filter={filter}
          filteredTags={filteredTags}
          setFilteredTags={setFilteredTags}
          filterOnClick={filterOnClick}
        />
      ))}
    </div>
  )
}

export default GridOptions
